import React from 'react';
import Link from 'next/link';
import { s as styled } from './styled-112a8bd0.js';

const Anchor = styled.a `
  color: unset;
  text-decoration: unset;
`;
const CustomLink = ({ targetPath, children, targetType = '_self', }) => {
    if (!targetPath)
        return React.createElement(React.Fragment, null, children);
    if (targetPath.startsWith('http'))
        return (React.createElement(Anchor, { target: targetType, href: targetPath }, children));
    return (React.createElement(Link, { href: targetPath, passHref: true },
        React.createElement(Anchor, { target: targetType }, children)));
};

export { CustomLink as C };
